module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown', {
    staticClass: "international",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleSetLanguage
    }
  }, [_c('div', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n      " + _vm._s(_vm.language === 'CN' ? "CN" : 'EN')), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right",
    staticStyle: {
      "font-size": "21px",
      "cursor": "pinter"
    }
  })])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    staticClass: "text",
    attrs: {
      "command": "EN",
      "disabled": _vm.language === 'EN'
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('el-dropdown-item', {
    staticClass: "text",
    attrs: {
      "command": "CN",
      "disabled": _vm.language === 'CN'
    }
  }, [_vm._v("中文")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04d21c28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LangSelect.vue
// module id = 1272
// module chunks = 169